import { render, staticRenderFns } from "./add-layout.vue?vue&type=template&id=1f0a7b93&scoped=true&"
import script from "./add-layout.vue?vue&type=script&lang=ts&"
export * from "./add-layout.vue?vue&type=script&lang=ts&"
import style0 from "./add-layout.vue?vue&type=style&index=0&id=1f0a7b93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0a7b93",
  null
  
)

export default component.exports